import {Card, Col, List, Radio, Row, DatePicker} from 'antd';
import moment from 'moment';
import React, {Component} from 'react';
import {connect} from 'react-redux';
import CallLogListDrawer from '../../containers/dashboard/callLoglist';
import ListDrawer from '../../containers/dashboard/list';
import Request from '../../request';

import {
    FaBlenderPhone,
    FaHeadphones,
    FaRunning,
    FaHeadset
} from "react-icons/fa";
import { RightsWrapper } from '../_utils/utils';

const data = [
    {name: 'Group A', value: 525},
    {name: 'Group B', value: 175}
];

const {RangePicker} = DatePicker

const COLORS = ['#56BFEE', '#69ccf9'];

class TelecallerCallsCount extends Component {

    constructor(props) {
        super(props)
        this.state = {
            value: 'lastMonth',
            newCounselling: [],
            drawer: false,
            callDrawer: false,
            drawerParam: {},
            drawerCallParam: {},
            followupDataCount: {},
            todayFollowupDataCount: {},
            overdueFollowupDataCount: {},
            totalConverted: {
                total: 0
            },
            callAttempts: {
                total: 0
            },
            callMisseds: {
                total: 0
            },
            callConnecteds: {
                total: 0
            },            
            dateRangeFilter: {
                startDate: moment().startOf('day').toDate(),
                endDate: moment().endOf('day').toDate(),
            },
            todayDoneFollowUps: {},
            todayFollowCounsellorWise: [],
            todayFollowRatingWise: [],
            totalRatingCount: 0,
            totalCounsellingWiseCount: 0
        }
    }


    async componentDidMount() {   
        let {dateRangeFilter} = this.props   
        this.setState({dateRangeFilter})  
        this.loadAllApis();

    }

    loadTelecallerGraph = async(telecallerId) => {
        let dateRangeFilter = this.state.dateRangeFilter;
        let params = {userId: telecallerId, dateRangeFilter};
        let dResponse = await Request.getTellecallerDashboardCount(params);
        if(dResponse) {
            this.setState({
                callAttempts: dResponse.callAttempts, 
                callMisseds: dResponse.callMisseds,
                callConnecteds: dResponse.callConnecteds,
                totalConverted: dResponse.totalConverted,
            })
        }
    }

    loadAllApis = () => {
        let localUser = JSON.parse(localStorage.getItem('user'));
        this.loadTelecallerGraph(localUser._id);
        let params = {userId: localUser._id}
        Request.getFollowupsData(params).then(({data: followupDataCount}) => {
            this.setState({followupDataCount})
        });
        Request.getTodayFollowupsData(params).then(({data: todayFollowupDataCount}) => {
            this.setState({todayFollowupDataCount})
        });
        Request.getOverdueFollowupsData(params).then(({data: overdueFollowupDataCount}) => {
            this.setState({overdueFollowupDataCount})
        });
    }

    componentWillReceiveProps(props) {
        const {timer} = this.props;
        if (props.timer !== timer) {
            this.loadAllApis();
        }
    }

    render() {
        const {dispatch} = this.props;
        const {
            drawer, 
            drawerParam,
            callDrawer,
            drawerCallParam,
            callAttempts,
            callMisseds,
            callConnecteds,
            totalConverted,
        } = this.state

        return (
            <div>
                <RightsWrapper myRight={"TelecallerCallCounts.view"}>
                <div className="site-card-wrapper">
                    {
                        callDrawer ? 
                            <CallLogListDrawer
                                param={drawerCallParam}
                                onClose={() => {
                                    this.setState({callDrawer: false})
                                }}/>
                        :null
                    }
                    {
                        drawer ? 
                            <ListDrawer
                                param={drawerParam}
                                onClose={() => {
                                    this.setState({drawer: false})
                                }}/>
                        :null
                    }
                    

                    <Row>
                        <Col span={6} style={{padding: '10px'}}>
                            <div className="info-box">
                                <span className="info-box-icon bg-color-3 elevation-1"><FaBlenderPhone /></span>
                                <div className="info-box-content">
                                    <span className="info-box-text">Call Attempt</span>
                                    <span className="info-box-number">
                                        <a onClick={() => {
                                            this.setState({
                                                callDrawer: true,
                                                drawerCallParam: {
                                                    title: 'Total Call Attempts',
                                                    callType: 'callAttempts',
                                                    count: callAttempts.total
                                                }
                                            })
                                        }}>
                                            <div style={{color: '#3a7ddd'}}> {callAttempts.total}</div>
                                        </a>                                       
                                    </span>
                                </div>
                            </div>
                        </Col>
                        <Col span={6} style={{padding: '10px'}}>
                            <div className="info-box">
                                <span className="info-box-icon bg-color-4 elevation-1"><FaHeadphones /></span>
                                <div className="info-box-content">
                                    <span className="info-box-text">Call Missed</span>
                                    <span className="info-box-number">
                                        <a onClick={() => {
                                            this.setState({
                                                callDrawer: true,
                                                drawerCallParam: {
                                                    title: 'Total Call Missed',
                                                    callType: 'callMissed',
                                                    count: callMisseds.total
                                                }
                                            })
                                        }}>
                                            <div style={{color: '#3a7ddd'}}> {callMisseds.total}</div>
                                        </a>                                        
                                    </span>
                                </div>
                            </div>
                        </Col>
                        <Col span={6} style={{padding: '10px'}}>
                            <div className="info-box">
                                <span className="info-box-icon bg-color-2 elevation-1"><FaHeadset /></span>
                                <div className="info-box-content">
                                    <span className="info-box-text">Call Connected</span>
                                    <span className="info-box-number">
                                        <a onClick={() => {
                                            this.setState({
                                                callDrawer: true,
                                                drawerCallParam: {
                                                    title: 'Total Call Connected',
                                                    callType: 'callConnected',
                                                    count: callConnecteds.total
                                                }
                                            })
                                        }}>
                                            <div style={{color: '#3a7ddd'}}> {callConnecteds.total}</div>
                                        </a>
                                    </span>
                                </div>
                            </div>
                        </Col>
                        <Col span={6} style={{padding: '10px'}}>
                            <div className="info-box">
                                <span className="info-box-icon bg-color-8 elevation-1"><FaRunning /></span>
                                <div className="info-box-content">
                                    <span className="info-box-text">Counselling To Registration Desk</span>
                                    <span className="info-box-number">
                                        <a onClick={() => {
                                            this.setState({
                                                drawer: true,
                                                drawerParam: {
                                                    title: `Counselling To Registration Desk`,
                                                    arr: totalConverted.arr,
                                                    count: totalConverted.total
                                                }
                                            })
                                        }}>
                                            <div style={{color: '#3a7ddd'}}> {totalConverted.total}</div>
                                        </a>  
                                    </span>
                                </div>
                            </div>
                        </Col>
                    </Row>
                    {/* <Row gutter={16}>
                        <Col span={24}>
                            <Card title={
                                <span>
                                    <img src={followUpsIcon} alt="Smiley face" height="22" width="22"/>
                                    <span style={{paddingLeft: '10px'}}>Followups Total ({followupDataCount && followupDataCount.totalFollowupCount ? followupDataCount.totalFollowupCount : 0})</span>
                                </span>
                            }
                            headStyle={{
                                backgroundColor: '#6d6d6d',
                                color: 'white',
                                minHeight: '11px',
                                fontSize: '17px'
                            }}
                            bodyStyle={{padding: '34px'}} bordered={false}
                            style={{height: '145px'}}>
                                <Row> 
                                    <Col span={3}> 
                                        <Row>
                                            <Col span={3}>
                                                <img src={ActiveIcon} alt="Smiley face" height="22" width="22"></img>
                                            </Col>
                                            <Col>
                                                <div className={styles.followupsVisa}>Active</div>
                                                {
                                                    followupDataCount && followupDataCount.activeCount != 0 ? 
                                                        <a onClick={() => {
                                                            dispatch(
                                                                getUrlPushWrapper('followUp.follow', {followUpType: 'Active'})
                                                            )
                                                        }}>
                                                            <div className={styles.followupsNumber} style={{color: '#8ac545'}}>
                                                                {followupDataCount && followupDataCount.activeCount}
                                                            </div>
                                                        </a> 
                                                    : <div className={styles.followupsNumber} style={{color: '#8ac545'}}> 0</div>
                                                }
                                            </Col>
                                        </Row> 
                                    </Col>
                                    <Col span={5}> 
                                        <Row>
                                            <Col span={3}> 
                                                <img src={DidntPickCallIcon} alt="Smiley face"height="22" width="22"></img>
                                            </Col>
                                            <Col>
                                                <div className={styles.followupsVisa}>Didn't Pick Call</div>
                                                {
                                                    followupDataCount && followupDataCount.pickCallCount != 0 ? 
                                                        <a onClick={() => {
                                                            dispatch(
                                                                getUrlPushWrapper('followUp.follow', {followUpType: 'Didn\'t Pick up Call'})
                                                            )
                                                        }}>
                                                            <div className={styles.followupsNumber} style={{color: 'orange'}}>
                                                                {followupDataCount && followupDataCount.pickCallCount}
                                                            </div>
                                                        </a> 
                                                    :
                                                        <div className={styles.followupsNumber}style={{color: 'orange'}}> 0</div>
                                                }
                                            </Col>
                                        </Row> 
                                    </Col>
                                    <Col span={5}> 
                                        <Row>
                                            <Col span={3}> 
                                                <img src={BusyIcon} alt="Smiley face" height="22" width="22"></img>
                                            </Col>
                                            <Col>
                                                <div className={styles.followupsVisa}>Busy(Call Later)</div>
                                                {
                                                    followupDataCount && followupDataCount.busyCallCount != 0 ? 
                                                        <a onClick={() => {
                                                            dispatch(
                                                                getUrlPushWrapper('followUp.follow', {followUpType: 'Busy, Call Later'})
                                                            )
                                                        }}>
                                                            <div className={styles.followupsNumber} style={{color: '#5dc294'}}>
                                                                {followupDataCount && followupDataCount.busyCallCount}
                                                            </div>
                                                        </a> 
                                                    :
                                                        <div className={styles.followupsNumber} style={{color: '#5dc294'}}> 0</div>
                                                }
                                            </Col>
                                        </Row> 
                                    </Col>
                                    <Col span={5}> 
                                        <Row>
                                            <Col span={3}> 
                                                <img src={NotInterestedIcon} alt="Smiley face" height="22" width="22"></img>
                                            </Col>
                                            <Col>
                                                <div className={styles.followupsVisa}>Not Intrested</div>
                                                {
                                                    followupDataCount && followupDataCount.notInterestedCount != 0 ?
                                                        <a onClick={() => {
                                                            dispatch(
                                                                getUrlPushWrapper('followUp.follow', {followUpType: 'Not Interested'})
                                                            )
                                                        }}>
                                                            <div className={styles.followupsNumber} style={{color: '#8e8e8e'}}>
                                                                {followupDataCount && followupDataCount.notInterestedCount}
                                                            </div>
                                                        </a> 
                                                    : 
                                                        <div className={styles.followupsNumber} style={{color: '#8e8e8e'}}> 0</div>
                                                }
                                            </Col>
                                        </Row>
                                    </Col>
                                    <Col span={4}> 
                                        <Row>
                                            <Col span={3}> 
                                                <img src={OutOfTownIcon} alt="Smiley face" height="22" width="22"></img>
                                            </Col>
                                            <Col>
                                                <div className={styles.followupsVisa}>Out of Town</div>
                                                {
                                                    followupDataCount && followupDataCount.outOfTownCount != 0 ?
                                                        <a onClick={() => {
                                                            dispatch(
                                                                getUrlPushWrapper('followUp.follow', {followUpType: 'Out Of town'})
                                                            )
                                                        }}>
                                                            <div className={styles.followupsNumber} style={{color: '#607d8b'}}>
                                                                {followupDataCount && followupDataCount.outOfTownCount}
                                                            </div>
                                                        </a> 
                                                    : <div className={styles.followupsNumber} style={{color: '#607d8b'}}> 0</div>
                                                }
                                            </Col>
                                        </Row>
                                    </Col>
                                    <Col span={2}> 
                                        <Row>
                                            <Col span={3}> 
                                                <img src={coldIcon} alt="Smiley face" height="22" width="22"></img>
                                            </Col>
                                            <Col>
                                                <div className={styles.followupsVisa}>Cold</div>
                                                {
                                                    followupDataCount && followupDataCount.coldCount != 0 ? 
                                                        <a onClick={() => {
                                                            dispatch(
                                                                getUrlPushWrapper('followUp.follow', {followUpType: 'Cold'})
                                                            )
                                                        }}>
                                                            <div className={styles.followupsNumber} style={{color: '#0b91d3'}}>
                                                                {followupDataCount && followupDataCount.coldCount}
                                                            </div>
                                                        </a> 
                                                    : <div className={styles.followupsNumber} style={{color: '#0b91d3'}}> 0</div>
                                                }
                                            </Col>
                                        </Row> 
                                    </Col>
                                </Row>
                            </Card>
                        </Col>
                        <Col span={24}>
                            <Card title={
                                <span>
                                    <img src={followUpsIcon} alt="Smiley face" height="22" width="22"/>
                                    <span style={{paddingLeft: '10px'}}>Today Followups ({todayFollowupDataCount && todayFollowupDataCount.totalFollowupCount ? todayFollowupDataCount.totalFollowupCount : 0})</span>
                                </span>
                            }
                            headStyle={{
                                backgroundColor: '#6d6d6d',
                                color: 'white',
                                minHeight: '11px',
                                fontSize: '17px'
                            }}
                            bodyStyle={{padding: '34px'}} bordered={false}
                            style={{height: '145px', marginTop: '30px'}}>
                                <Row> 
                                    <Col span={3}> 
                                        <Row>
                                            <Col span={3}>
                                                <img src={ActiveIcon} alt="Smiley face" height="22" width="22"></img>
                                            </Col>
                                            <Col>
                                                <div className={styles.followupsVisa}>Active</div>
                                                {
                                                    todayFollowupDataCount && todayFollowupDataCount.activeCount != 0 ? 
                                                        <a onClick={() => {
                                                            dispatch(
                                                                getUrlPushWrapper('followUp.follow', {followUpType: 'Active', followUpShow: 'Today'})
                                                            )
                                                        }}>
                                                            <div className={styles.followupsNumber} style={{color: '#8ac545'}}>
                                                                {todayFollowupDataCount && todayFollowupDataCount.activeCount}
                                                            </div>
                                                        </a> 
                                                    : <div className={styles.followupsNumber} style={{color: '#8ac545'}}> 0</div>
                                                }
                                            </Col>
                                        </Row> 
                                    </Col>
                                    <Col span={5}> 
                                        <Row>
                                            <Col span={3}> 
                                                <img src={DidntPickCallIcon} alt="Smiley face"height="22" width="22"></img>
                                            </Col>
                                            <Col>
                                                <div className={styles.followupsVisa}>Didn't Pick Call</div>
                                                {
                                                    todayFollowupDataCount && todayFollowupDataCount.pickCallCount != 0 ? 
                                                        <a onClick={() => {
                                                            dispatch(
                                                                getUrlPushWrapper('followUp.follow', {followUpType: 'Didn\'t Pick up Call', followUpShow: 'Today'})
                                                            )
                                                        }}>
                                                            <div className={styles.followupsNumber} style={{color: 'orange'}}>
                                                                {todayFollowupDataCount && todayFollowupDataCount.pickCallCount}
                                                            </div>
                                                        </a> 
                                                    :
                                                        <div className={styles.followupsNumber}style={{color: 'orange'}}> 0</div>
                                                }
                                            </Col>
                                        </Row> 
                                    </Col>
                                    <Col span={5}> 
                                        <Row>
                                            <Col span={3}> 
                                                <img src={BusyIcon} alt="Smiley face" height="22" width="22"></img>
                                            </Col>
                                            <Col>
                                                <div className={styles.followupsVisa}>Busy(Call Later)</div>
                                                {
                                                    todayFollowupDataCount && todayFollowupDataCount.busyCallCount != 0 ? 
                                                        <a onClick={() => {
                                                            dispatch(
                                                                getUrlPushWrapper('followUp.follow', {followUpType: 'Busy, Call Later', followUpShow: 'Today'})
                                                            )
                                                        }}>
                                                            <div className={styles.followupsNumber} style={{color: '#5dc294'}}>
                                                                {todayFollowupDataCount && todayFollowupDataCount.busyCallCount}
                                                            </div>
                                                        </a> 
                                                    :
                                                        <div className={styles.followupsNumber} style={{color: '#5dc294'}}> 0</div>
                                                }
                                            </Col>
                                        </Row> 
                                    </Col>
                                    <Col span={5}> 
                                        <Row>
                                            <Col span={3}> 
                                                <img src={NotInterestedIcon} alt="Smiley face" height="22" width="22"></img>
                                            </Col>
                                            <Col>
                                                <div className={styles.followupsVisa}>Not Intrested</div>
                                                {
                                                    todayFollowupDataCount && todayFollowupDataCount.notInterestedCount != 0 ?
                                                        <a onClick={() => {
                                                            dispatch(
                                                                getUrlPushWrapper('followUp.follow', {followUpType: 'Not Interested', followUpShow: 'Today'})
                                                            )
                                                        }}>
                                                            <div className={styles.followupsNumber} style={{color: '#8e8e8e'}}>
                                                                {todayFollowupDataCount && todayFollowupDataCount.notInterestedCount}
                                                            </div>
                                                        </a> 
                                                    : 
                                                        <div className={styles.followupsNumber} style={{color: '#8e8e8e'}}> 0</div>
                                                }
                                            </Col>
                                        </Row>
                                    </Col>
                                    <Col span={4}> 
                                        <Row>
                                            <Col span={3}> 
                                                <img src={OutOfTownIcon} alt="Smiley face" height="22" width="22"></img>
                                            </Col>
                                            <Col>
                                                <div className={styles.followupsVisa}>Out of Town</div>
                                                {
                                                    todayFollowupDataCount && todayFollowupDataCount.outOfTownCount != 0 ?
                                                        <a onClick={() => {
                                                            dispatch(
                                                                getUrlPushWrapper('followUp.follow', {followUpType: 'Out Of town', followUpShow: 'Today'})
                                                            )
                                                        }}>
                                                            <div className={styles.followupsNumber} style={{color: '#607d8b'}}>
                                                                {todayFollowupDataCount && todayFollowupDataCount.outOfTownCount}
                                                            </div>
                                                        </a> 
                                                    : <div className={styles.followupsNumber} style={{color: '#607d8b'}}> 0</div>
                                                }
                                            </Col>
                                        </Row>
                                    </Col>
                                    <Col span={2}> 
                                        <Row>
                                            <Col span={3}> 
                                                <img src={coldIcon} alt="Smiley face" height="22" width="22"></img>
                                            </Col>
                                            <Col>
                                                <div className={styles.followupsVisa}>Cold</div>
                                                {
                                                    todayFollowupDataCount && todayFollowupDataCount.coldCount != 0 ? 
                                                        <a onClick={() => {
                                                            dispatch(
                                                                getUrlPushWrapper('followUp.follow', {followUpType: 'Cold', followUpShow: 'Today'})
                                                            )
                                                        }}>
                                                            <div className={styles.followupsNumber} style={{color: '#0b91d3'}}>
                                                                {todayFollowupDataCount && todayFollowupDataCount.coldCount}
                                                            </div>
                                                        </a> 
                                                    : <div className={styles.followupsNumber} style={{color: '#0b91d3'}}> 0</div>
                                                }
                                            </Col>
                                        </Row> 
                                    </Col>
                                </Row>
                            </Card>
                        </Col>
                        <Col span={24}>
                            <Card title={
                                <span>
                                    <img src={followUpsIcon} alt="Smiley face" height="22" width="22"/>
                                    <span style={{paddingLeft: '10px'}}>Overdue Followups ({overdueFollowupDataCount && overdueFollowupDataCount.totalFollowupCount ? overdueFollowupDataCount.totalFollowupCount : 0})</span>
                                </span>
                            }
                            headStyle={{
                                backgroundColor: '#6d6d6d',
                                color: 'white',
                                minHeight: '11px',
                                fontSize: '17px'
                            }}
                            bodyStyle={{padding: '34px'}} bordered={false}
                            style={{height: '145px', marginTop: '30px'}}>
                                <Row> 
                                    <Col span={3}> 
                                        <Row>
                                            <Col span={3}>
                                                <img src={ActiveIcon} alt="Smiley face" height="22" width="22"></img>
                                            </Col>
                                            <Col>
                                                <div className={styles.followupsVisa}>Active</div>
                                                {
                                                    overdueFollowupDataCount && overdueFollowupDataCount.activeCount != 0 ? 
                                                        <a onClick={() => {
                                                            dispatch(
                                                                getUrlPushWrapper('followUp.follow', {followUpType: 'Active', followUpShow: 'OverDue'})
                                                            )
                                                        }}>
                                                            <div className={styles.followupsNumber} style={{color: '#8ac545'}}>
                                                                {overdueFollowupDataCount && overdueFollowupDataCount.activeCount}
                                                            </div>
                                                        </a> 
                                                    : <div className={styles.followupsNumber} style={{color: '#8ac545'}}> 0</div>
                                                }
                                            </Col>
                                        </Row> 
                                    </Col>
                                    <Col span={5}> 
                                        <Row>
                                            <Col span={3}> 
                                                <img src={DidntPickCallIcon} alt="Smiley face"height="22" width="22"></img>
                                            </Col>
                                            <Col>
                                                <div className={styles.followupsVisa}>Didn't Pick Call</div>
                                                {
                                                    overdueFollowupDataCount && overdueFollowupDataCount.pickCallCount != 0 ? 
                                                        <a onClick={() => {
                                                            dispatch(
                                                                getUrlPushWrapper('followUp.follow', {followUpType: 'Didn\'t Pick up Call', followUpShow: 'OverDue'})
                                                            )
                                                        }}>
                                                            <div className={styles.followupsNumber} style={{color: 'orange'}}>
                                                                {overdueFollowupDataCount && overdueFollowupDataCount.pickCallCount}
                                                            </div>
                                                        </a> 
                                                    :
                                                        <div className={styles.followupsNumber}style={{color: 'orange'}}> 0</div>
                                                }
                                            </Col>
                                        </Row> 
                                    </Col>
                                    <Col span={5}> 
                                        <Row>
                                            <Col span={3}> 
                                                <img src={BusyIcon} alt="Smiley face" height="22" width="22"></img>
                                            </Col>
                                            <Col>
                                                <div className={styles.followupsVisa}>Busy(Call Later)</div>
                                                {
                                                    overdueFollowupDataCount && overdueFollowupDataCount.busyCallCount != 0 ? 
                                                        <a onClick={() => {
                                                            dispatch(
                                                                getUrlPushWrapper('followUp.follow', {followUpType: 'Busy, Call Later', followUpShow: 'OverDue'})
                                                            )
                                                        }}>
                                                            <div className={styles.followupsNumber} style={{color: '#5dc294'}}>
                                                                {overdueFollowupDataCount && overdueFollowupDataCount.busyCallCount}
                                                            </div>
                                                        </a> 
                                                    :
                                                        <div className={styles.followupsNumber} style={{color: '#5dc294'}}> 0</div>
                                                }
                                            </Col>
                                        </Row> 
                                    </Col>
                                    <Col span={5}> 
                                        <Row>
                                            <Col span={3}> 
                                                <img src={NotInterestedIcon} alt="Smiley face" height="22" width="22"></img>
                                            </Col>
                                            <Col>
                                                <div className={styles.followupsVisa}>Not Intrested</div>
                                                {
                                                    overdueFollowupDataCount && overdueFollowupDataCount.notInterestedCount != 0 ?
                                                        <a onClick={() => {
                                                            dispatch(
                                                                getUrlPushWrapper('followUp.follow', {followUpType: 'Not Interested', followUpShow: 'OverDue'})
                                                            )
                                                        }}>
                                                            <div className={styles.followupsNumber} style={{color: '#8e8e8e'}}>
                                                                {overdueFollowupDataCount && overdueFollowupDataCount.notInterestedCount}
                                                            </div>
                                                        </a> 
                                                    : 
                                                        <div className={styles.followupsNumber} style={{color: '#8e8e8e'}}> 0</div>
                                                }
                                            </Col>
                                        </Row>
                                    </Col>
                                    <Col span={4}> 
                                        <Row>
                                            <Col span={3}> 
                                                <img src={OutOfTownIcon} alt="Smiley face" height="22" width="22"></img>
                                            </Col>
                                            <Col>
                                                <div className={styles.followupsVisa}>Out of Town</div>
                                                {
                                                    overdueFollowupDataCount && overdueFollowupDataCount.outOfTownCount != 0 ?
                                                        <a onClick={() => {
                                                            dispatch(
                                                                getUrlPushWrapper('followUp.follow', {followUpType: 'Out Of town', followUpShow: 'OverDue'})
                                                            )
                                                        }}>
                                                            <div className={styles.followupsNumber} style={{color: '#607d8b'}}>
                                                                {overdueFollowupDataCount && overdueFollowupDataCount.outOfTownCount}
                                                            </div>
                                                        </a> 
                                                    : <div className={styles.followupsNumber} style={{color: '#607d8b'}}> 0</div>
                                                }
                                            </Col>
                                        </Row>
                                    </Col>
                                    <Col span={2}> 
                                        <Row>
                                            <Col span={3}> 
                                                <img src={coldIcon} alt="Smiley face" height="22" width="22"></img>
                                            </Col>
                                            <Col>
                                                <div className={styles.followupsVisa}>Cold</div>
                                                {
                                                    overdueFollowupDataCount && overdueFollowupDataCount.coldCount != 0 ? 
                                                        <a onClick={() => {
                                                            dispatch(
                                                                getUrlPushWrapper('followUp.follow', {followUpType: 'Cold', followUpShow: 'OverDue'})
                                                            )
                                                        }}>
                                                            <div className={styles.followupsNumber} style={{color: '#0b91d3'}}>
                                                                {overdueFollowupDataCount && overdueFollowupDataCount.coldCount}
                                                            </div>
                                                        </a> 
                                                    : <div className={styles.followupsNumber} style={{color: '#0b91d3'}}> 0</div>
                                                }
                                            </Col>
                                        </Row> 
                                    </Col>
                                </Row>
                            </Card>
                        </Col>
                    </Row> */}
                </div>
                </RightsWrapper>
            </div>
        )
    }
}

const mapDispatchToProps = dispatch => {
    return {
        dispatch
    }
}

export default connect(mapDispatchToProps)
(TelecallerCallsCount)
